/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
// import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { SupplierListReq, DeleteSupplierReq, SupplierData } from 'Store/supplier/types'
import { supplierListAPI, deleteSupplierAPI } from 'Store/supplier/api'
import {
  selectSupplierList,
  selectSupplierListEvent,
  selectSupplierActionEvent,
} from 'Store/supplier/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/supplier/actions'
import { getBankName, getDefaultStatus, getSupplierPaymentType } from 'helpers/format'
import { FranchiseTag, StatusTag } from 'Components/utilities'
import { DefaultStatus, menuDefaultStatus } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import BannerDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import theme, { MyTheme } from 'Components/common/Theme'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { SelectItem, UploadForm } from 'Components/form'
import LinkText from 'Components/text/LinkText'

type Props = {} & ReduxProps

const Suppliers: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [showInfo, setShowInfo] = useState(false)
  const [selectedSupplier, setSelectedSupplier] = useState(undefined as SupplierData | undefined)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  const colors = theme.colors

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    order_by: 'id',
    sort: 'desc',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: SupplierListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      merchant_id: currentUser?.activeMerchant?.id || 0,
      status: filter.status,
      order_by: filter.order_by || 'id',
      sort: filter.sort || 'desc',
    }
    dispatch(supplierListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteSupplierReq = {
      id,
    }
    dispatch(deleteSupplierAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const renderStatus = (status: DefaultStatus) => (
    <StatusTag isPass={status === DefaultStatus.ACTIVE} text={getDefaultStatus(status)} />
  )

  const renderActionButton = (text: string, record: SupplierData) => (
    <Space size="middle">
      {record?.supplier_type !== 'franchise' && (
        <ActionButton
          text=""
          icon={<EditOutlined />}
          label="แก้ไข"
          action="edit"
          onClick={() => onClickEdit(record.id)}
        />
      )}
    </Space>
  )

  const renderCompanyInfo = (name: string, record: SupplierData) => (
    <LinkNo
      color={colors.black}
      onClick={() => {
        setSelectedSupplier(record)
        setShowInfo(true)
      }}
    >
      {name}
    </LinkNo>
  )

  const renderCompanyName = (name: string, record: SupplierData) => (
    <FranchiseTag text={name} isFranchise={false} />
  )

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'รหัสบริษัท',
      dataIndex: 'supplier_code',
      key: 'supplier_code',
      render: renderCompanyInfo,
      sorter: true,
    },
    {
      title: 'ชื่อบริษัท/Supplier',
      dataIndex: 'name',
      key: 'name',
      render: renderCompanyName,
      width: '25%',
      sorter: true,
    },
    {
      title: 'เครดิตจ่ายหนี้/วัน',
      dataIndex: 'payment_period',
      key: 'payment_period',
      render: (value: any) => `${value} วัน`,
      sorter: true,
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
      sorter: true,
    },
    {
      title: isFranchise ? '' : 'แก้ไข',
      key: 'action',
      width: isFranchise ? '0px' : '',
      render: renderActionButton,
    },
  ]

  const renderInfo = (title: string, value: any) => {
    return (
      <Row>
        <Col lg={10} xs={12}>
          <InfoTitle>{title} </InfoTitle>
        </Col>
        <Col lg={14} xs={12}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const renderWithdrawInfo = () => {
    return (
      <WithdrawWrapper>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            {renderInfo('รหัสบริษัท', selectedSupplier?.supplier_code)}
            {renderInfo('ชื่อบริษัท/Supplier', selectedSupplier?.name)}
            {renderInfo('เลขประจำตัวผู้เสียภาษี', selectedSupplier?.tax_payer_id)}
            {renderInfo('เบอร์โทรศัพท์มือถือ', selectedSupplier?.mobile_no)}
            {renderInfo('เบอร์โทรศัพท์', selectedSupplier?.phone_no)}
            {renderInfo('อีเมล', selectedSupplier?.email)}
            {renderInfo('ที่อยู่บริษัท', selectedSupplier?.address)}
          </Col>
          <Col span={24}>ข้อมูลการชำระเงิน</Col>
          <Col span={24}>
            {renderInfo('ชื่อบัญชี', selectedSupplier?.account_name)}
            {renderInfo('เลขที่บัญชี', selectedSupplier?.account_no)}
            {renderInfo('ธนาคาร', getBankName(selectedSupplier?.account_bank))}
            {renderInfo('สาขา', selectedSupplier?.account_branch)}
            {renderInfo('รูปแบบการชำระเงิน', getSupplierPaymentType(selectedSupplier?.payment_type))}
            {renderInfo('ระยะเวลาชำระเงิน', selectedSupplier?.payment_period + ' วัน')}
          </Col>
          <Col span={24}>
            <UploadForm
              token={currentUser.accessToken}
              onUpdateData={() => {}}
              currentFile={selectedSupplier?.account_book_bank || ''}
              folder="supplier-account"
              listType="text"
              isPrivate={true}
              name="account_book_bank"
              description=""
              isRequired={false}
              isError={false}
              label="ไฟล์หน้าบัญชี"
              readOnly={true}
            />
            {renderInfo('สถานะ', renderStatus(selectedSupplier?.status || DefaultStatus.INACTIVE))}
          </Col>
        </Row>
      </WithdrawWrapper>
    )
  }

  const InfoModal = (
    <ConfirmWithChild
      title={selectedSupplier?.name || ''}
      isShow={showInfo}
      handleOk={() => {}}
      handleCancel={() => setShowInfo(false)}
      child={renderWithdrawInfo()}
      hasConfirm={false}
      hasCancel={false}
      cancelBtnTxt="ปิด"
    />
  )

  const DetailDrawer = (
    <BannerDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="middle" gutter={[8, 8]}>
        <Col xs={24} md={18}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={10}>
              <SearchInput
                placeholder="ค้นหาชื่อหรือรหัส บริษัท/Supplier"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={10}>
              <SelectItem
                name={'status'}
                label={''}
                isRequired={true}
                value={filter.status}
                menu={menuDefaultStatus}
                placeHolder={'สถานะ'}
                onChange={(val: any): void => onFilter('status', val)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </Col>
        {!isFranchise && (
          <Col>
            <Space size="middle">
              <PrimaryButton text="เพิ่มข้อมูลบริษัท" icon={<PlusOutlined />} onClick={onClickCreate} />
            </Space>
          </Col>
        )}
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout selected="supplier" title="ข้อมูลบริษัท/Supplier" label="">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          onSort={onSort}
          scrollX={500}
        />
        {LoadingModal}
        {DetailDrawer}
        {ConfirmDeleteModal}
        {InfoModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectSupplierList(state),
    listEvent: selectSupplierListEvent(state),
    event: selectSupplierActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const WithdrawWrapper = styled.div`
  padding: 10px;
  text-align: left;
`
const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`
export default connect(mapStateToProps)(Suppliers)
